export const APP_KEY = '0a271bb5-eb05-4bae-adf1-9b6840018783';